import { render, staticRenderFns } from "./CandleStick.vue?vue&type=template&id=3c396b6a&scoped=true&"
import script from "./CandleStick.vue?vue&type=script&lang=js&"
export * from "./CandleStick.vue?vue&type=script&lang=js&"
import style0 from "./CandleStick.vue?vue&type=style&index=0&id=3c396b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c396b6a",
  null
  
)

export default component.exports